module.exports = __webpack_public_path__ + "img/4-2.65cf93f3.png";